import { useQuery } from '@tanstack/react-query';
import { useUserInfo } from 'Store/userInfo';
import getReportOperators from 'Api/report-attendance/getReportOperators';
import getReportOperatorsRequest from './model/request/getReportOperatorsRequest';
import getReportOperatorsResponse from './model/response/getReportOperatorsResponse';

const useGetReportOperators = ({ filter, enabled }) => {
  const { roleName } = useUserInfo();
  return useQuery({
    queryKey: ['report-operators', filter],
    queryFn: async () => {
      const queries = getReportOperatorsRequest(filter);

      const response = await getReportOperators(queries);

      return getReportOperatorsResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: roleName === 'Owner' && enabled,
  });
};

export default useGetReportOperators;
